export default "__VITE_ASSET__DKaFTWMq__"